import { ENDPOINTS } from '../../types/endpoints';
export var urlUtils = {
    makeURLWithQuery: function (url, queryObj) {
        var queryParams = new URLSearchParams(queryObj);
        return "".concat(url, "?").concat(queryParams.toString());
    },
    /**
     * @description: to get only first part of long pathname,
     * e.g.:
     * /referral/advisor/name => /referral
     * /referral/employee => /referral
     * / => /
     * /mortgageroute1 => /mortgageroute1
     */
    getPathnameScope: function (url) {
        var parts = url.split('/');
        if (parts.length === 1 || parts[1] === '') {
            return ENDPOINTS.ROOT;
        }
        return "/".concat(parts[1]);
    },
};
